import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Link } from 'react-router-dom';
export default function CategoryPage() {
    const { t } = useTranslation();

    const [categorie, setCategorie] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/categories");
                setCategorie(response.data.category);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };
        fetchCategories();
    }, []);


    return (
        <>
            <section className="landingPages">
                <div className="container h-full flex flex-col gap-[10px] justify-center">
                    <div className="btmAni30002 text-[35px] font-bold text-white">{t("Main Categories")}</div>
                    <div className="btmAni25002 flex items-center gap-[3px] text-white">
                        <Link to={"/"}>{t("Home")}</Link>
                        <span>-</span>
                        <div>{t("Main Categories")}</div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[30px]">
                    <h2 className="text-2xl font-bold">{t("Main Categories")}</h2>
                    <div className="flex items-center flex-wrap gap-[15px]">
                        {categorie.map(items => (
                            <Link
                                key={items.category_id}
                                to={`/subCategories/${items.category_id}`}
                                className="flex flex-col items-center text-center"
                            >
                                <div className="back-category w-[100px] h-[100px] shadow-[0px_0px_10px_#0000000f] p-1.5 rounded-md flex items-center justify-center">
                                    <img
                                        className="w-[125px] h-[125px] object-contain"
                                        src={`https://laravel-api.aj-mart.com/storage/app/public/${items.category_img}`}
                                        alt={""}
                                    />
                                </div>
                                <div>{items.category_name_E}</div>
                            </Link>
                        ))}

                    </div>
                </div>
            </section>
        </>
    );
}
